/**
 * @generated SignedSource<<6af5335da35a516a5fdedd387ad6cc7d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type AppColorPalette = "ACCENT_1" | "ACCENT_2" | "ACCENT_3" | "BACKGROUND_1" | "BACKGROUND_2" | "BLACK" | "GRAY" | "PRIMARY" | "WHITE" | "%future added value";
export type ButtonTextStyleType = "SENTENCE_CASE" | "UPPERCASE" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type InternBrandStylePalette_brand$data = {
  readonly appConfig: {
    readonly accent1PaletteLight: string;
    readonly accent2PaletteLight: string;
    readonly accent3PaletteLight: string;
    readonly background1PaletteLight: string;
    readonly background2PaletteLight: string;
    readonly buildTheme: {
      readonly badgeBackground: AppColorPalette | null;
      readonly badgeForeground: AppColorPalette | null;
      readonly buttonBorderThickness: number | null;
      readonly buttonCornerRadius: number | null;
      readonly buttonTextStyle: ButtonTextStyleType | null;
      readonly id: string;
      readonly navigationBackground: AppColorPalette | null;
      readonly navigationForeground: AppColorPalette | null;
      readonly onboardingBackground: AppColorPalette | null;
      readonly onboardingForeground: AppColorPalette | null;
      readonly pillContainerBackground: AppColorPalette | null;
      readonly primaryButtonBackground: AppColorPalette | null;
      readonly primaryButtonForeground: AppColorPalette | null;
      readonly primaryPillBackground: AppColorPalette | null;
      readonly primaryPillForeground: AppColorPalette | null;
      readonly secondaryButtonOutline: AppColorPalette | null;
      readonly secondaryPillOutline: AppColorPalette | null;
    };
    readonly id: string;
    readonly primaryPaletteLight: string;
  };
  readonly id: string;
  readonly internStyle: {
    readonly colorPalettes: ReadonlyArray<{
      readonly accentBackground: string;
      readonly accentForeground: string;
      readonly adPriority: number;
      readonly background: string;
      readonly componentColors: {
        readonly backgrounds: {
          readonly background1: string;
          readonly background2: string;
        };
        readonly badge: {
          readonly background: string;
          readonly foreground: string;
        };
        readonly button: {
          readonly background: string;
          readonly foreground: string;
          readonly outline: string;
        };
        readonly navBar: {
          readonly background: string;
          readonly foreground: string;
        };
        readonly onboarding: {
          readonly background: string;
          readonly foreground: string;
        };
        readonly shortcuts: {
          readonly background: string;
          readonly container: string;
          readonly foreground: string;
          readonly outline: string;
        };
      };
      readonly emailPriority: number;
      readonly foreground: string;
    }>;
    readonly navbar: {
      readonly background: string;
      readonly foreground: string;
    } | null;
    readonly primaryButton: {
      readonly background: string;
      readonly borderColor: string | null;
      readonly foreground: string;
    } | null;
    readonly suggestedButtonStyle: {
      readonly borderRadius: number;
      readonly borderWidth: number;
      readonly textStyle: ButtonTextStyleType;
    } | null;
  } | null;
  readonly " $fragmentType": "InternBrandStylePalette_brand";
};
export type InternBrandStylePalette_brand$key = {
  readonly " $data"?: InternBrandStylePalette_brand$data;
  readonly " $fragmentSpreads": FragmentRefs<"InternBrandStylePalette_brand">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "background",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "foreground",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "outline",
  "storageKey": null
},
v4 = [
  (v1/*: any*/),
  (v2/*: any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InternBrandStylePalette_brand",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "InternBrandStyle",
      "kind": "LinkedField",
      "name": "internStyle",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "InternBrandStyleColorPalette",
          "kind": "LinkedField",
          "name": "colorPalettes",
          "plural": true,
          "selections": [
            (v1/*: any*/),
            (v2/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "accentBackground",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "accentForeground",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "adPriority",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "emailPriority",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "BrandComponentColorsSuggestions",
              "kind": "LinkedField",
              "name": "componentColors",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "BrandButtonColorsSuggestion",
                  "kind": "LinkedField",
                  "name": "button",
                  "plural": false,
                  "selections": [
                    (v1/*: any*/),
                    (v2/*: any*/),
                    (v3/*: any*/)
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "BrandShortcutsColorsSuggestion",
                  "kind": "LinkedField",
                  "name": "shortcuts",
                  "plural": false,
                  "selections": [
                    (v1/*: any*/),
                    (v2/*: any*/),
                    (v3/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "container",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "BrandBadgeColorsSuggestion",
                  "kind": "LinkedField",
                  "name": "badge",
                  "plural": false,
                  "selections": (v4/*: any*/),
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "BrandNavBarColorsSuggestion",
                  "kind": "LinkedField",
                  "name": "navBar",
                  "plural": false,
                  "selections": (v4/*: any*/),
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "BrandBackgroundColorsSuggestion",
                  "kind": "LinkedField",
                  "name": "backgrounds",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "background1",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "background2",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "BrandOnboardingColorsSuggestion",
                  "kind": "LinkedField",
                  "name": "onboarding",
                  "plural": false,
                  "selections": (v4/*: any*/),
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "InternBrandStyleBasicColorPalette",
          "kind": "LinkedField",
          "name": "primaryButton",
          "plural": false,
          "selections": [
            (v1/*: any*/),
            (v2/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "borderColor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "InternBrandStyleBasicColorPalette",
          "kind": "LinkedField",
          "name": "navbar",
          "plural": false,
          "selections": (v4/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "InternBrandStyleSuggestedButtonStyle",
          "kind": "LinkedField",
          "name": "suggestedButtonStyle",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "borderRadius",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "borderWidth",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "textStyle",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "BrandAppConfigType",
      "kind": "LinkedField",
      "name": "appConfig",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "primaryPaletteLight",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "accent1PaletteLight",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "accent2PaletteLight",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "accent3PaletteLight",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "background1PaletteLight",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "background2PaletteLight",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "BrandAppConfigBuildThemeType",
          "kind": "LinkedField",
          "name": "buildTheme",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "primaryButtonBackground",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "primaryButtonForeground",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "secondaryButtonOutline",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "primaryPillBackground",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "primaryPillForeground",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "secondaryPillOutline",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "pillContainerBackground",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "badgeBackground",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "badgeForeground",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "navigationBackground",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "navigationForeground",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "onboardingBackground",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "onboardingForeground",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "buttonBorderThickness",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "buttonCornerRadius",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "buttonTextStyle",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "BrandType",
  "abstractKey": null
};
})();

(node as any).hash = "b55ff9ea42b184e3e063d2ff9c3ccf8b";

export default node;
